// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import servicio from "assets/images/servicio-tecnico.jpg"

function ServicioTecnico() {

  return (
    <>
      <DefaultNavbar
        routes={routes}
        sticky
      />
      <MKBox minHeight="30vh"></MKBox>
      <Card
        minHeight="30vh"
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox component="section" >
          <Container>
            <Grid
              container
              item
              flexDirection="column"
              sx={{ textAlign: "justify", my: 6, mx: "auto", px: 0.75 }}
            >
              <MKTypography variant="h1" fontWeight="bold" color="#537aba" style={{marginBottom: "30px"}} align='center'>
                Servicio Técnico
              </MKTypography>
              <MKTypography variant="h3" fontWeight="bold" color="#537aba" style={{marginBottom: "30px"}} align='center'>
                Especialistas en la reparación de Equipo de Bombeo Industrial
              </MKTypography>
              <MKTypography variant="body1" color="text" style={{marginBottom: "20px"}}>
                En ARES contamos con un área especializada de reparación, servicio técnico y análisis de las bombas industriales más comunes.
              </MKTypography>
              <MKTypography variant="body1" color="text" style={{marginBottom: "20px"}}>
                Podemos reparar la mayoría de los modelos de bombas de doble diafragma, bombas de vacío y bombas centrífugas. Sin embargo, si tienes otro equipo de bombeo, con gusto contáctanos y te atenderemos para reparar tu bomba.
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
        <MKBox component="section">
            <Container>
                <Grid container spacing={3}>
                    <Grid item xs={12} lg={12}>
                        <MKBox
                            component="img"
                            src={servicio}
                            alt="servicio"
                            width="80%"
                            my="auto"
                            opacity={1}
                            style={{display: "flex"}}
                            sx={{margin: "auto"}}
                        />
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
        <MKBox component="section" >
          <Container>
            <Grid
              container
              item
              flexDirection="column"
              sx={{ textAlign: "justify", my: 6, mx: "auto", px: 0.75 }}
            >
              <MKTypography variant="h1" fontWeight="bold" color="#537aba" style={{marginBottom: "30px"}} align='center'>
                Reparación de equipo de bombeo
              </MKTypography>
              <MKTypography variant="body1" color="text" style={{marginBottom: "20px"}}>
                En ARES contamos con un gran servicio técnico especializado.
              </MKTypography>
              <MKTypography variant="body1" color="text" style={{marginBottom: "20px"}}>
                Te ofrecemos un completo diagnóstico sin costo. 
              </MKTypography>
              <MKTypography variant="body1" color="text" style={{marginBottom: "20px"}}>
                Dentro de nuestra reparación y mantenimiento de todo equipo de bombeo, te ofrecemos un servicio completo para reparar. Vuelve a dejar como nuevo tu equipo de bombeo. Contamos con refacciones especializadas de marcas originales o genéticas.
              </MKTypography>
              <MKTypography variant="body1" color="text" style={{marginBottom: "20px"}}>
                Además, te ofrecemos consultoría, capacitación y entrenamiento a tu equipo industrial SIN COSTO. Te visitamos en tu planta o en nuestras instalaciones certificadas.
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default ServicioTecnico;
